<template>
  <v-container>
    <loading
      :active.sync="isLoading2"
      loader="dots"
      color="#1E88E5"
      :is-full-page="fullPage"
      :can-cancel="false"
    ></loading>
    <v-snackbar v-model="snackbar" top :timeout="timeout" :color="color">{{
      text
    }}</v-snackbar>
    <base-material-card
      color="indigo darken-3"
      icon="mdi-package-variant-closed"
      inline
    >
      <template v-slot:after-heading class="text-lg-center">
        <div class="text-center display-2 font-weight-bold grey--text">
          {{ title }}
        </div>
      </template>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-n4"
        label="Buscar..."
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-3"></v-divider>

      <template class="mt-n3">
        <v-row justify-space-around>
          <v-col cols="12" sm="10">
            <v-btn
              color="indigo darken-4"
              dark
              small
              class="mb-2"
              @click="Mostrar()"
              >Agregar nueva lista</v-btn
            >
          </v-col>
        </v-row>
      </template>

      <v-data-table
        dense
        :search.sync="search"
        :items-per-page="5"
        :headers="headers"
        :sort-desc="[false, true]"
        :items="PriceList"
        class="elevation-1"
      >
        <template v-slot:item.isDefault="{ item }">
          <v-tooltip bottom color="indigo">
            <template v-slot:activator="{ on }">
              <v-icon
                class="mr-2"
                v-if="item.isDefault"
                color="indigo"
                dark
                v-on="on"
                >mdi-lock-alert</v-icon
              >
            </template>
            <span>Lista marcada como Default</span>
          </v-tooltip>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="mr-2"
                color="indigo lighten-3"
                @click="EditList(item)"
                v-on="on"
                >mdi-lead-pencil</v-icon
              >
            </template>
            <span>Editar nombre de lista</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                class="mr-2"
                color="success"
                @click="editItem(item)"
                v-on="on"
                >mdi-pencil</v-icon
              >
            </template>
            <span>Editar detalles de la lista de precios</span>
          </v-tooltip>

          <v-icon
            class="mr-2"
            v-if="!item.isDefault"
            color="error"
            @click="deleteItem(item)"
            >mdi-trash-can</v-icon
          >
        </template>
      </v-data-table>
      <!-- Agregar una nueva lista de precios -->
      <modal-add-nueva-lista
        :dialog="dialog2"
        @Cerrar="Cerrar"
        @SaveData="SaveData"
        :edited="edited"
        :editedItem="editedItem"
        :CaniSetDefault="CaniSetDefault"
      />

      <!-- Editar los detalle del listado de precios  -->
      <modal-lista-precios
        :dialog="dialog"
        @Close="Close"
        :titleList="titleList"
        :ListItems="ListItems"
        :priceListId="priceListId"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import axios from "axios";
export default {
  props: ["title"],
  mounted() {
    //const b = this.PriceList;
    //if (b === 0) {
    this.LoadPriceList();
    // }
    //this.LoadPriceList();
    /*  if (this.$store.state.PriceList.length == 0) {
      this.LoadPriceList();
    } */
  },
  components: {
    ModalListaPrecios: () => import("./Modals/listaprecios"),
    ModalAddNuevaLista: () => import("./Modals/addlistaprecios"),
    Loading,
  },
  data: () => ({
    search: null,
    dialog: false,
    dialog2: false,
    titleList: "",
    edited: false,
    CaniSetDefault: true,
    editedItem: [],
    ListItems: [],
    priceListId: 0,
    headers: [
      { text: "", value: "isDefault", sortable: false },
      { text: "Nombre", value: "name", align: "start" },
      { text: "Descripcion", value: "description", align: "start" },

      { text: "Editar/Borrar", value: "action", align: "end", sortable: false },
    ],

    snackbar: null,
    timeout: null,
    color: null,
    text: null,
    isLoading2: false,
    fullPage: false,
  }),
  methods: {
    EditList(item) {
      this.edited = true;
      this.editedItem = [];

      this.editedItem.push(item);
      this.dialog2 = true;
    },
    LoadPriceList() {
      axios
        .get("/api/Catalogs/PriceList", {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.$store.commit("SET_PRICE_LIST", data);
        });
    },
    SaveData(values) {
      if (this.edited) {
        axios
          .put(
            "/api/Catalogs/PriceList/" + this.editedItem[0].id,
            {
              name: values.name,
              description: values.description,
              isDefault: values.isDefault,
            },
            {
              headers: {
                bussinessId: this.$store.state._bussinessAccountId,
              },
            }
          )
          .then((result) => {
            return result.data;
          })
          .then((data) => {
            this.snackbar = true;
            this.timeout = 4000;
            this.color = "success";
            this.text = "Exito al actualizar la lista";
            this.Cerrar();

            this.LoadPriceList();
          })
          .catch((err) => {});
      } else {
        axios
          .post(
            "/api/Catalogs/PriceList",
            {
              name: values.name,
              description: values.description,
              isDefault: values.isDefault,
            },
            {
              headers: {
                bussinessId: this.$store.state._bussinessAccountId,
              },
            }
          )
          .then((result) => {
            return result.data;
          })
          .then((data) => {
            this.snackbar = true;
            this.timeout = 4000;
            this.color = "success";
            this.text = "Exito al registra nueva lista";
            this.Cerrar();

            this.LoadPriceList();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    Cerrar() {
      // Cierra el modal de alta de nueva lista
      this.dialog2 = false;
    },
    // Editar la lista de precios.
    editItem(item) {
      this.priceListId = item.id;
      axios
        .get(`/api/Catalogs/PriceList/${this.priceListId}`, {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.ListItems = data.productPrices;
          this.titleList = item.name;
          this.dialog = true;
        })
        .catch((err) => {
          console.log(err);
        });

      /*;*/
    },
    deleteItem(item) {
      Swal.fire({
        title: "¿Desea Borrar esta lista ?",
        type: "warning",
        text: "Por favor confirme que desea borrar esta lista",
        showCancelButton: true,
        confirmButtonText: "Si, deseo borrarlo",
        cancelButtonText: "No deseo borrarlo",
      }).then((result) => {
        if (result.value) {
          this.isLoading2 = true;
          axios
            .delete("/api/Catalogs/PriceList/" + item.id, {
              headers: {
                bussinessId: this.$store.state._bussinessAccountId,
              },
            })
            .then((result) => {
              return result.data;
            })
            .then((data) => {
              this.snackbar = true;
              this.timeout = 4000;
              this.color = "success";
              this.text = "Exito al borrar la lista";
              this.LoadPriceList();
              this.isLoading2 = false;
            })
            .catch((err) => {
              this.isLoading2 = false;
              this.LoadPriceList();
              Swal.fire({
                title: "Error",
                text:
                  "Ocurrio un error al eliminar... Por favor intenta de nuevo",
                type: "error",
              });
            });
        }
      });
    },
    Close() {
      // Cierra el modal de editar lista
      this.dialog = false;
    },
    Mostrar() {
      // Muestra el modal para agregar una nueva lista de precios
      this.edited = false;
      this.dialog2 = true;
    },
  },
  computed: {
    PriceList: {
      get() {
        return this.$store.state.PriceList;
      },
      set(val) {
        this.$store.state.commit("SET_PRICE_LIST", val);
      },
    },

    /*    PriceList() {
      this.$store.state.PriceList.forEach((element) => {
        if (element.isDefault) {
          this.CaniSetDefault = false;
        }
      });

      return this.$store.state.PriceList;
    }, */
  },
};
</script>
